import React from 'react';
import PropTypes from 'prop-types';
import { ToastContainer } from 'react-toastify';
import Header from 'components/organisms/header';
import 'react-toastify/dist/ReactToastify.css';

const Layout = ({ children, disableNavigation }) => (
  <div>
    <Header disableNavigation={disableNavigation} />
    <div className="content">{children}</div>
    <ToastContainer />
  </div>
);

Layout.propTypes = {
  children: PropTypes.object,
  disableNavigation: PropTypes.bool,
};

export default Layout;
